import { ReportTypeMap } from '../types'
import { infoByColumnId } from '../lib/infoByColumnId'

// Given a client-side column ID, return the corresponding API sort column accessor
export const convertToSortApiColumn = <RT extends keyof ReportTypeMap>(
  reportType: RT,
  column: ReportTypeMap[RT]['columnId'],
) => infoByColumnId({ reportType, id: column }).sortKey
